import { Configuration, PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { NotificationProvider } from '@hm-group/bads-react'
import '@hm-group/releasenoteswebcomponent/SystemVersionComponent.js'
import { createRoot } from 'react-dom/client'

import App from '@/App'
import {
  articlePurposeUrl,
  carryOverFlag,
  colorwayUrl,
  imageBrowser,
  loginRequest,
  matchingArticleUrl,
  msalConfig,
  oneArticleModal,
} from '@/AuthConfig'
import AppNotificationToast from '@/components/notification-toast/AppNotificationToast'
import { NetworkProvider } from '@/context/providers/NetworkContext'
import { AppConfig } from '@/model/entities/app-config.interface'
import { ApiConstants } from '@/utils/constants/ApiConstant'
import { LoadApplicationInsights } from '@/utils/helper/AppInsights'
import { LoadClarity } from '@/utils/helper/Clarity'
import 'material-icons/iconfont/filled.css'
import './index.scss'

async function fetchConfig(): Promise<void> {
  try {
    const response = await fetch('/config.json')
    if (!response.ok) {
      throw new Error('Failed to fetch config')
    }
    const configResp: AppConfig = await response.json()

    const msalConfigData: Configuration = {
      ...msalConfig,
      auth: {
        ...msalConfig.auth,
        clientId: configResp.ClientId,
        authority: configResp.Authority,
        redirectUri: configResp.RedirectUri,
      },
    }

    loginRequest.scopes = [configResp.WebAppScope] as unknown as string[]
    ApiConstants.baseUrl = configResp.ApiUrl
    imageBrowser.url = configResp.ImageBrowserUrl
    oneArticleModal.url = configResp.OneArticleUrl
    articlePurposeUrl.url = configResp.ArticlePurposeUrl
    matchingArticleUrl.url = configResp.MatchingArticleUrl
    colorwayUrl.url = configResp.ColorwayUrl
    carryOverFlag.flag = String(configResp.CarryOverFlag)
    LoadApplicationInsights(configResp.AppInsightsConnectionString)
    LoadClarity(configResp.Environment, configResp.ClarityProjectId)

    const msalInstance = new PublicClientApplication(msalConfigData)

    const rootElement = document.getElementById('root')
    const root = createRoot(rootElement || document.createElement('div'))

    root.render(
      <NotificationProvider>
        <AppNotificationToast />
        <NetworkProvider>
          <MsalProvider instance={msalInstance}>
            <App />,
          </MsalProvider>
        </NetworkProvider>
      </NotificationProvider>,
    )
  } catch (error) {
    console.error('Error:', error)
  }
}

fetchConfig()
